module.exports = __webpack_public_path__ + "img/16.bc129680.jpg";